"use strict";

define('rs/components/pagination/pagination',['vertebrae', 'evisions/evimenu/evimenu'], function (Vertebrae, EVIMenu) {
  var Pagination = Vertebrae.View.extend({
    MAX_PAGES: 5,
    className: 'e3-pagination',
    templates: {
      'e3-pagination': 'renderInitFragment'
    },
    events: {
      'click [data-page]': 'handlePageClick',
      'click [data-action]': 'handleActionClick'
    },
    render: function render(pages) {
      var canGoPrevious = !(pages[0] || {}).active,
        canGoNext = !(_.last(pages) || {}).active,
        activePage = _.find(pages, function (page) {
          return page.active;
        }),
        activeIndex = _.indexOf(pages, activePage),
        len = pages.length,
        previousPlaceholder = false,
        previousPages = [],
        nextPages = [],
        hidden = false,
        nextPlaceholder = false;
      if (pages.length <= 1) {
        hidden = true;
      }
      var leftSideSubtract, leftSideIndex, rightSideAdd, rightSideIndex;
      this.off(null, null, this);
      if (len > this.MAX_PAGES) {
        var otherPageCount = this.MAX_PAGES - 1;
        if (activeIndex > 1) {
          otherPageCount = otherPageCount - 2;
        }
        if (activeIndex < len - 2) {
          otherPageCount = otherPageCount - 2;
        }
        otherPageCount = Math.max(otherPageCount, 2);
        leftSideSubtract = Math.floor(otherPageCount / 2);
        leftSideIndex = Math.max(activeIndex - leftSideSubtract, 0);
        rightSideAdd = otherPageCount - (activeIndex - leftSideIndex);
        rightSideIndex = activeIndex + rightSideAdd;
        if (rightSideIndex >= len) {
          leftSideSubtract += rightSideIndex - len + 1;
          rightSideIndex = len - 1;
          leftSideIndex = Math.max(activeIndex - leftSideSubtract, 0);
        }
        if (rightSideIndex < len - 2) {
          nextPlaceholder = _.last(pages);
        } else if (rightSideIndex == len - 2) {
          rightSideIndex++;
        }
        if (leftSideIndex > 1) {
          previousPlaceholder = pages[0];
        } else if (leftSideIndex == 1) {
          leftSideIndex--;
        }
        pages = [].concat(pages).slice(leftSideIndex, rightSideIndex + 1);
      }
      this.$el.html(this.renderInitFragment({
        hidden: hidden,
        pages: pages,
        canGoNext: canGoNext,
        canGoPrevious: canGoPrevious,
        previousPlaceholder: previousPlaceholder,
        nextPlaceholder: nextPlaceholder
      }));
      return this;
    },
    showDropMenu: function showDropMenu(pages, el) {
      EVIMenu.show({
        className: 'rs-menu',
        element: el,
        container: el,
        caret: 'top-right',
        offset: {
          top: 49,
          left: -180
        }
      }, _.pluck(pages, 'label')).bind(this).tap(function (i) {
        if (pages[i]) {
          this.trigger('page:select', pages[i].page);
        }
      });
    },
    handlePageClick: function handlePageClick(ev) {
      var el = $(ev.currentTarget),
        page = el.data('page');
      if (!el.closest('.e3-page').hasClass('active')) {
        this.trigger('page:select', page);
      }
    },
    handleActionClick: function handleActionClick(ev) {
      var el = $(ev.currentTarget),
        action = el.data('action');
      this.trigger('action:' + action, el);
    }
  });
  return Pagination;
});

